import React from 'react';
import { Typography } from '@guildeducationinc/recess';
import usePathways from '@src/hooks/usePathways';
import {
  CAREER_ACCELERATOR_ONLY_BODY,
  CAREER_TOPIC_PAGES_ONLY_BODY,
  FULL_CAREER_RESOURCES_BODY,
} from '@src/constants';
import { useMemberPlanContext } from '@src/context/MemberPlanContext';
import CareerAcceleratorActionCard from './CareerAcceleratorActionCard/CareerAcceleratorActionCard';
import EmployerCareerSection from './EmployerCareerSection/EmployerCareerSection';
import './CareerResources.scss';

const CareerResources: React.FC = () => {
  const { memberPlan } = useMemberPlanContext();
  const { pathways, loading } = usePathways();

  const careerPathwaysEnabled = !!pathways?.length && !loading;

  const hasCareerAccelerator = memberPlan?.hasCareerAccelerator;
  const hasAllCareerResources = hasCareerAccelerator && careerPathwaysEnabled;
  const hasOnlyCareerAccelerator = hasCareerAccelerator && !careerPathwaysEnabled;
  const hasOnlyCareerPathways = !hasCareerAccelerator && careerPathwaysEnabled;

  const heading = 'Step into your future.';
  let body = '';

  if (hasAllCareerResources) {
    body = FULL_CAREER_RESOURCES_BODY;
  } else if (hasOnlyCareerAccelerator) {
    body = CAREER_ACCELERATOR_ONLY_BODY;
  } else if (hasOnlyCareerPathways) {
    body = CAREER_TOPIC_PAGES_ONLY_BODY;
  }

  return (
    <div className='careerResources'>
      <Typography variant='h2'>{heading}</Typography>
      <Typography className='careerSectionBody' variant='body1'>
        {body}
      </Typography>
      <div className='careerSectionContent'>
        {hasCareerAccelerator && <CareerAcceleratorActionCard />}
        {careerPathwaysEnabled && <EmployerCareerSection />}
      </div>
    </div>
  );
};

export default CareerResources;
